import { AppBundle } from 'api/optimalprint-sdk.d';
import { PublicAssetProductPrice } from 'store/price/types';
import { AddToCartFlow, BundledProduct } from 'store/product/types';
import { GettyImagesImageSearchResponse } from 'store/studioSearch/types';

export interface Product {
  name: string;
  description: string;
  productId: number;
  productTypeId: number;
  categoryId: number;
  abstractProductId: number;
  slug: string;
  productUid: string;
  followUrl: string;
  initialPrice: PublicAssetProductPrice;
  finalPrice: PublicAssetProductPrice;
  illustrationUrl?: any;
}

export enum PublicAssetSources {
  Bridgeman = 'bridgeman',
  ManualUpload = 'manual-upload',
  Shutterstock = 'shutterstock',
}

export interface PublicAssetAbstractProductData {
  isGettySearchResultProductPageEnabled: boolean;
  redirectUrl?: any;
  products: Product[];
}

export interface PublicAssetImageData {
  artistName?: string;
  designName?: string;
  preview?: string;
  description?: string;
}

export interface PublicAssetProductState {
  publicAssetAbstractProductData?: PublicAssetAbstractProductData;
  abstractProducts: { [slug: string]: AppBundle.Api.Entity.App.V1.IAbstractProduct };
  selectedAbstractProduct?: AppBundle.Api.Entity.App.V1.IAbstractProduct;
  currentProduct?: AppBundle.Api.Entity.App.V1.AbstractProduct.IProductItem;
  source: PublicAssetSources | string;
  sourceImageId: string;
  selectedAbstractProductName?: string;
  productId?: number;
  moreArtPrints?: GettyImagesImageSearchResponse;
  similarImages?: GettyImagesImageSearchResponse;
  publicAssetImageData?: PublicAssetImageData;
  selectedBundleProducts: BundledProduct[];
  forcedPreviews?: { [index: number]: string };
  loadingProducts?: boolean;
  addingToCartFlow: AddToCartFlow;
}

export enum PRODUCT_SLUGS {
  poster = 'studio-selection-posters',
  canvas = 'studio-selection-canvas',
  wallpaper = 'studio-selection-wallpapers',
  mug = 'mug',
  toteBags = 'tote-bags',
}
